// extracted by mini-css-extract-plugin
export default {"serial_input":"serial_input_SLx2Auoh"};